import { Authentication } from "../../../types";
import { CustomSchema } from "./types";

export const authenticationSchema: CustomSchema<Authentication>[] = [
];
